<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
      <div class="userdetailside">
        <sidebarSettingsComponent></sidebarSettingsComponent>
      </div>
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main" style="width:75%;">
        <div class="col-md-12 ">
          <!-- code for table -->
          <b-row>
            <div class="col-md-12">
              <b-col md="12">
                <b-card-body>
                  <div class="row mt-4">
                    <div class="col-md-6 pull-left">
                      <h3>Inspection Time Window</h3>
                    </div>
                  </div>
                  <form @submit.prevent="validatefrom()">
                     <div class="row mt-2">
                    <div class="col">
                      <label>Select Day</label>
                      <select
                        class="form-select form-control"
                        id="selected_days"
                        name="selected_days"
                        v-model="selected_days" required
                      >
                        <option value="">Select Day</option>
<!--                         
                        
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Thursday">Thursday</option> -->
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                        <!-- <option value="Sunday">Sunday</option> -->
                        
                        
                      </select>
                    </div>
                    <div class="col">
                      <label>Select From Time</label><br />
                      <div class="row">
                        <div>
                          <select
                            class="form-select form-control"
                            id="selected_fromtime"
                            name="selected_fromtime"
                            v-model="selected_fromtime" required
                          >
                            <option value="">Select Time</option>
                            <option value="01">01</option>
                            <option value="02">02</option>
                            <option value="03">03</option>
                            <option value="04">04</option>
                            <option value="05">05</option>
                            <option value="06">06</option>
                            <option value="07">07</option>
                            <option value="08">08</option>
                            <option value="09">09</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                          </select>
                        </div>
                        &nbsp;
                        <div>
                          <select
                            class="form-select form-control"
                            id="selected_fromAmPm"
                            name="selected_fromAmPm"
                            v-model="selected_fromAmPm" required
                          >
                            <option value="">Select</option>
                            <option value="AM">AM</option>
                            <!-- <option value="PM">PM</option> -->
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <label>Select To Time</label><br />
                      <div class="row">
                        <div>
                          <select
                            class="form-select form-control"
                            id="selected_toTime"
                            name="selected_toTime"
                            v-model="selected_toTime" required
                          >
                            <option value="">Select Time</option>
                            <option value="01">01</option>
                            <option value="02">02</option>
                            <option value="03">03</option>
                            <option value="04">04</option>
                            <option value="05">05</option>
                            <option value="06">06</option>
                            <option value="07">07</option>
                            <option value="08">08</option>
                            <option value="09">09</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                          </select>
                        </div>
                        &nbsp;
                        <div>
                          <select
                            class="form-select form-control"
                            id="selected_toAmPm"
                            name="selected_toAmPm"
                            v-model="selected_toAmPm" required
                          >
                            <option value="">Select</option>
                            <!-- <option value="AM">AM</option> -->
                            <option value="PM">PM</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="col">
                      <button type="submit" class="btn btn-primary mt-4">
                        Submit
                      </button>
                    </div>
                  </div>
                  </form>
                  <hr />
                  <div>
                    <b-table striped hover 
                        :items="time_details" 
                        :fields="fields" 
                        :current-page="currentPage"
                        :per-page="perPage"
                        :bordered="true" class="mt-4"
                        show-empty
                        stacked="md"
                        :busy="isBusy"
                        responsive
                      >
                      <div
                          slot="table-busy"
                          class="text-center text-danger my-2"
                        >
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                      <template slot="action" slot-scope="row">
                         <i
                          @click="showEditModal(row.item)"
                          data-toggle="tooltip"
                          class="fa fa-pencil-square-o"
                          aria-hidden="true"
                          style=" color: green;"
                          ><label style="color:black">Edit Details</label>
                        </i>
                      </template>
                    </b-table>
                  </div>
                </b-card-body>
              </b-col>
            </div>
          </b-row>
          <div class="col-md-12">
            <b-pagination
              v-model="currentPage"
              :total-rows="total_roecount"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </div>
        </div>
      </div>

      <b-modal
        id="inspectionTimeEditModal"
        size="md"
        title="Edit Inspection Day/Time Details"
        v-model="inspectionTimeEditModal"
        @ok="inspectionTimeEditModal = false"
      >
        <form @submit.prevent="validateEditForm()">
          <b-col>
              <label>Selected Day</label>
              <b-form-select id="edited_day" name="edited_day" v-model="selected_day" :options="options"></b-form-select>
          </b-col>
          <b-col class="mt-2">
              <label>Selected From Time</label>
              <b-form-select id="edited_fromTime" name="edited_fromTime" v-model="selected_fromTimeEdit" :options="Fromtimes"></b-form-select>
          </b-col>
           <b-col class="mt-2">
              <label>Selected To Time</label>
              <b-form-select id="edited_fromTime" name="edited_fromTime" v-model="selected_toTimeEdit" :options="Totimes"></b-form-select>
          </b-col>
           <div class="col-md-12 pull-right mt-3">
                  <footer class="column has-text-right pull-right">
                    <b-button variant="primary" size="md" type="submit"
                      >Submit</b-button
                    >&nbsp;
                    <b-button
                      variant="secondary"
                      size="md"
                      type="button"
                      @click="inspectionTimeEditModal=false"
                      >Cancel</b-button
                    >
                  </footer>
                </div>
        </form>
      </b-modal>    

    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";

import sidebarSettingsComponent from "./_sidebarSettingsComponent.vue";

const axios = require("axios");
export default {
  name: "Tabs",
  components: {
    sidebarSettingsComponent,
  },
  data() {
    return {
      user_type: "",
      email_id:"",
      time_details:[],
      fields: [
        { key: "day", label: "Day" },
        { key: "from_time", label: "From Time" },
        { key: "to_time", label: "To Time"},
        { key: "action", label: "Edit"},
      ],
      selected_days: "",
      selected_fromtime: "",
      selected_fromAmPm: "",
      selected_toTime: "",
      selected_toAmPm: "",
      inspectionTimeEditModal: false,
      selected_day: '',
      options: [
        { value: "" , text: "Select Day"},
          // { value: "Monday", text: 'Monday' },
          // { value: "Tuesday", text: 'Tuesday' },
          // { value: "Wednesday", text: 'Wednesday' }, 
          // { value: "Thursday", text: 'Thursday' },
          { value: "Friday", text: 'Friday' },  
          { value: "Saturday", text: 'Saturday' },
        //   { value: "Sunday", text: 'Sunday' },
        ],
        selected_fromTimeEdit:'',
        Fromtimes:[
          { value: "" , text: "Select Time"},
          { value: "01 AM", text: '01 AM' },
          { value: "02 AM", text: '02 AM' },
          { value: "03 AM", text: '03 AM' },
          { value: "04 AM", text: '04 AM' },
          { value: "05 AM", text: '05 AM' },
          { value: "06 AM", text: '06 AM' },
          { value: "07 AM", text: '07 AM' },
          { value: "08 AM", text: '08 AM' },
          { value: "09 AM", text: '09 AM' },
          { value: "10 AM", text: '10 AM' },
          { value: "11 AM", text: '11 AM' },
          { value: "12 AM", text: '12 AM' },
      ],
      selected_toTimeEdit:'',
        Totimes:[
          { value: "" , text: "Select Time"},
          { value: "01 PM", text: '01 PM' },
          { value: "02 PM", text: '02 PM' },
          { value: "03 PM", text: '03 PM' },
          { value: "04 PM", text: '04 PM' },
          { value: "05 PM", text: '05 PM' },
          { value: "06 PM", text: '06 PM' },
          { value: "07 PM", text: '07 PM' },
          { value: "08 PM", text: '08 PM' },
          { value: "09 PM", text: '09 PM' },
          { value: "10 PM", text: '10 PM' },
          { value: "11 PM", text: '11 PM' },
          { value: "12 PM", text: '12 PM' },
      ],
      id:"",
      currentPage: 1,
      perPage: 10,
      total_roecount: 0,
    };
  },
  created: function() {
    this.getInspectionList();
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.user_type = userInfo[0].user_type;
    this.email_id = userInfo[0].email_id;
    
  },

  methods: {

    validatefrom:function(){
       document.getElementById("overlay").style.display = "block";
      console.log(this.selected_days,
      this.selected_fromtime + ' ' + this.selected_fromAmPm,
      this.selected_toTime + ' ' + this.selected_toAmPm
      )

      const Obj ={
        day: this.selected_days,
        from_time: this.selected_fromtime + ' ' + this.selected_fromAmPm,
        to_time: this.selected_toTime + ' ' + this.selected_toAmPm,
        created_by: this.email_id

      }
      axios.post(`${CONSTANTS.API_URL}/addInspectionTime`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
          if(response.data.returnmsg == "Successful")
          {
             this.$fire({
                 text:"Information Addedd Successlly",
                 type: "success",
                 timer: 30000
              })
              this.getInspectionList()
          }
          else{

              this.$fire({
                 text:response.data.returnvalue,
                 type: "error",
                 timer: 30000
              })
              this.getInspectionList()

          }
      })
    },

    getInspectionList(){
      const Obj={}
      axios.post(`${CONSTANTS.API_URL}/getInspectionList`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
          if(response.data.returnmsg == "Successful")
          {
            this.time_details= response.data.returnvalue;
            this.total_roecount = response.data.returnvalue.length;
          }
      })

    },

    showEditModal(editdetails){
      
      this.selected_day= editdetails.day
      this.selected_fromTimeEdit = editdetails.from_time,
      this.selected_toTimeEdit = editdetails.to_time
      this.id=editdetails.id
      console.log(this.selected_fromTimeEdit)
      this.inspectionTimeEditModal=true
    },

    validateEditForm:function(){
      // alert()
      document.getElementById("overlay").style.display = "block";
      console.log(this.selected_day, this.selected_fromTimeEdit, this.selected_toTimeEdit)
       const Obj ={
        day: this.selected_day,
        from_time: this.selected_fromTimeEdit,
        to_time: this.selected_toTimeEdit,
        id: this.id

      }
      axios.post(`${CONSTANTS.API_URL}/updateInspectionTime`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
          if(response.data.returnmsg == "Successful")
          {
            document.getElementById("overlay").style.display = "block";
             this.$fire({
                 text:"Information Updated SuccessFully",
                 type: "success",
                 timer: 30000
              })
              this.inspectionTimeEditModal=false
              this.getInspectionList()
          }
          else{
             this.$fire({
                 text:response.data.returnvalue,
                 type: "error",
                 timer: 30000
              })
              // this.inspectionTimeEditModal=false
              this.getInspectionList()
          }
      })
    }
  },
};
</script>
<style>
@media (max-width: 1040px) {
  .userdetailside {
    display: none;
  }
}
@media (min-width: 1040px) {
  .userdetailsidebar {
    display: none;
  }
}

</style>
